import { Fragment } from 'react';
import type { MorceauDuTuto } from '../partage/api/types';

/**
 * Un texte du tuto, ce qu'il faut écrire ou cliquer en gras (ticket 45). Les morceaux
 * viennent du serveur (`server/src/domain/aide/enGras.ts`) : chacun se pose en texte ou dans un
 * `<b>`, jamais en HTML. Un titre tapé par l'utilisateur reste donc du texte, quoi qu'il
 * contienne.
 */
export function TexteDuTuto({ morceaux }: { morceaux: MorceauDuTuto[] }) {
  return (
    <>
      {morceaux.map((m, i) => (m.gras ? <b key={i}>{m.texte}</b> : <Fragment key={i}>{m.texte}</Fragment>))}
    </>
  );
}
